// disable eslint for the non used imports
/* eslint-disable */
import { React, Component, useEffect, useCallback, useMemo } from "react";
// import "./home.css";
import styled from "styled-components";
// import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { faCoffee, faPalette } from '@fortawesome/free-solid-svg-icons';
import { useSpecialButtons } from "../../ui/specialButtons/SpecialButtonsContext";
import { logPageView, setUser } from '../../analytics/GoogleAnalytics';
import AotdAuthorsLeaderboard from "../stats_page/AOTDLeaderboard";
import BirthdayButton from "../birthday_button/BirthdayButton";
import { IS_BETA } from "../../config/env";
import { useGetRespectSummaryQuery } from "../../services/rtkApi/respectApi";
import { SitelineHome, SitelineDock } from "../../features/siteline";
import { NextBadges } from "../../features/badges/goals";
import { useHomeBanner } from "../../features/homeBanner";
import { useMediaQuery } from "../../hooks/useMediaQuery";
// import WebPushSettings from "../profile_page/WebPushSettings";
// import TelegramSettings from "../profile_page/TelegramSettings";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// function getRoles(str) {
//   // convert the input string to an array by splitting at each comma
//   var arr = str.split(",");
//   // return the array
//   return arr;
// }

const isBeta = IS_BETA;

const HomePage = () => {
  const user = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const specialButtonsContext = useSpecialButtons();
  // The home is ONE scroll context — a plain document scroll on every viewport.
  // Desktop used to lock the page to the viewport and give the siteline column
  // its own internal scroll, which made the wheel behave differently depending
  // on where the pointer was. Now: mobile keeps the feed stacked inline, desktop
  // moves it into the floating siteline dock (bottom-right chip + drawer).
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const isAuthenticated = user.bootstrapStatus === "ready" && Boolean(user.token);
  const { data: respectData } = useGetRespectSummaryQuery(undefined, {
    skip: !isAuthenticated,
  });

  // announcemnt text 1 and 2
  // desktop moved the feed into the floating dock, so the "scroll down" nudge
  // only holds on the stacked (mobile/tablet) layout.
  // edited from the top of /admin (features/homeBanner)
  const { text1: announcementText1, text2: announcementText2 } = useHomeBanner();

  // extract stable register function to avoid depending on entire context object
  const register = specialButtonsContext?.register;

  useEffect(() => {
    logPageView();
    if (user.username) {
      setUser(user.username);
    }
  }, [user.username]);

  useEffect(() => {
    document.title = `NΛSOS`;
  }, [user.username]);

  // memoize click handlers so config objects can stay stable
  const goCoffeeRate = useCallback(() => navigate('/coffee-rate'), [navigate]);
  const goAotd = useCallback(() => navigate('/art-of-the-day'), [navigate]);

  // memoize configs so they don't get recreated each render
  const special2Config = useMemo(() => ({
    icon: faCoffee,
    onClick: goCoffeeRate,
    ariaLabel: 'coffee rate'
  }), [goCoffeeRate]);

  const special1Config = useMemo(() => ({
    label: 'aotd',
    icon: faPalette,
    onClick: goAotd,
    ariaLabel: 'art of the day'
  }), [goAotd]);

  // register special buttons for mobile bottom bar
  // depend only on stable inputs: register function and memoized configs
  useEffect(() => {
    if (!register) {
      return;
    }
    register('special2', special2Config);
    register('special1', special1Config);

    // cleanup on unmount
    return () => {
      register('special1', null);
      register('special2', null);
    };
  }, [register, special1Config, special2Config]);


  return (
    <HomeContainer>
      <HomeMain>
      <div>

        <h1>"This is the NΛSOS website"</h1>
        <h3><i>The website is in <span className="text-indigo-500 font-extrabold">beta</span> version... please report any bugs you find...</i></h3>
        {user._id && (
          <h2>Your rank is "{(user.role ?? "member").split(", ")}"</h2>
        )}
        {/* {user._id && respectData?.data?.position && (
          <PositionDisplay>
            <PositionBadge>{respectData.data.position.badge}</PositionBadge>
            <PositionName>{respectData.data.position.name}</PositionName>
          </PositionDisplay>
        )} */}

        <BirthdayButton celebrationOnly />
        {/* Every cards surface (CardsButton, DropLiveCta, HandStrip) is
            intentionally off the home screen until the cards launch. The
            components are untouched and /cards still works by URL.
            PendingActions lives on /profile only — nagging on the landing page
            was noise, and the profile is where you actually resolve them. */}
        <ProfilePromptsRow />
        {/* {isAuthenticated && <WebPushSettings placement="home" />} */}
      </div>

      {announcementText1 && announcementText1.length > 0 && (
        <BoxDivImportant>
          {announcementText1}
        </BoxDivImportant>
      )}

      {announcementText2 && announcementText2.length > 0 && (
        <BoxDivImportant2>
          {announcementText2}
        </BoxDivImportant2>
      )}


      {/* <BoxDivImportant>
        you dont have an account yet? thats sad, you need to get an invite to enter now. ask someone that is already registered. they may spend one of their 2 invites for you.
      </BoxDivImportant> */}
      {/* arrow down to the telegram settings */}
      {/* <h1 className="text-center m-[-40px] z-[10]">
        <FontAwesomeIcon className="text-indigo-500 z-[10] hover:text-indigo-600 transition-all duration-300" icon={faArrowDownLong} size="2x" />
      </h1>
      <TelegramSettings /> */}

      {/* <BoxDivImportant2>
        <p>COFFEE RATE FOR EVERYONE!!!!!!!</p>
        <p>rate your coffee in the website!! <Link to="/coffee-rate">rate your coffee</Link></p>
      </BoxDivImportant2> */}

        <AotdAuthorsLeaderboard />
        {isAuthenticated && <NextBadges variant="compact" />}
      </HomeMain>

      {/* Continuous siteline feed. Stacked below 1024px it just extends the
          page (one scroll, no nested scroller); from 1024px it lives in the
          floating dock instead, so the home stops fighting the wheel. Exactly
          one of the two mounts, so the feed is fetched once. */}
      {!isDesktop && (
        <HomeFeed>
          <SitelineHome />
        </HomeFeed>
      )}
      {isDesktop && <SitelineDock />}
    </HomeContainer>
  );
};

const ProfilePromptsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
  margin: 4px 0 10px;

  &:empty {
    display: none;
    margin: 0;
  }
`;

/* ONE scroll context: the home is a normal document, top to bottom, on every
   viewport. No viewport lock, no internal scrollers — the wheel does the same
   thing wherever the pointer is. */
const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 100vh;
  background-color: ${isBeta ? '#9b96fd' : '#b7ffae'};
  text-emphasis-color: #223126;
  padding: 15px;

  @media (min-width: 1024px) {
    padding: 14px 18px 0;
  }
`;

const HomeMain = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    /* keep the reading measure sane now that the feed no longer takes 40% */
    max-width: 1100px;
    width: 100%;
    min-width: 0;
  }
`;

/* Stacked (mobile/tablet) only — the feed flows continuously with the page and
   just extends it. From 1024px the feed lives in SitelineDock instead. */
const HomeFeed = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin-top: 10px;
`;

const BoxDiv = styled.div`
  border: 1px solid;
  padding: 10px;
  box-shadow: 5px 10px rgba(0, 0, 0, 0.7);
  background-color: #ffe95dbc;
  margin: 20px;
  justify-content: start;
`;

const PositionDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0 8px;
`;

const PositionBadge = styled.span`
  font-size: 1.4rem;
  line-height: 1;
`;

const PositionName = styled.span`
  font-size: 1rem;
  font-weight: 700;
  color: #4f3e76;
  letter-spacing: 0.03em;
`;

const BoxDivImportant = styled.div`
  border: 4px solid;
  padding: 5px;
  padding-left: 10px;
  box-shadow:   0px 0px 10px 2px rgba(255, 111, 0, 0.907), 5px 10px rgba(0, 0, 0, 0.7) ;
  background-color: #ff611dbc;
  margin: 20px;
  justify-content: start;
  font-weight: 700;
  font-size: 1.5rem;
`;

const BoxDivImportant2 = styled.div`
  border: 4px solid;
  padding: 5px;
  padding-left: 10px;
  box-shadow:   0px 0px 10px 2px rgba(255, 0, 230, 0.907), 5px 10px rgba(0, 0, 0, 0.7) ;
  background-color: #ff1dc3bc;
  margin: 20px;
  justify-content: start;
  font-weight: 700;
  font-size: 1.5rem;
`;

const StyledParagraph = styled.p`
  color: #333; // Example color
  font-size: 1rem; // Example font size
  margin: 10px 0; // Example margin
`;

const HighlightedText = styled.p`
  color: #e672e6; // Example highlight color
  font-size: 0.9rem; // Slightly larger font size for emphasis
  margin: 10px 0;
  // font-weight: bold;
`;


class IpCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ip: null,
      country: null,
      city: null,
      isLoading: true,
      provider: null,
      error: false,
    };
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_IP_API_LINK)
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          ip: response.ip,
          country: response.country,
          city: response.city,
          provider: response.organization,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          error: true,
        });
      });
  }

  render() {
    if (this.state.isLoading) {
      return <div>Wait...</div>;
    } else if (!this.state.error) {
      if (
        this.state.provider ===
        "Ote SA (Hellenic Telecommunications Organisation)"
      ) {
        return (
          <div>
            <p>
              Your IP is {this.state.ip} and you live in {this.state.country} (
              {this.state.city}). Btw change your provider, cosmote sucks
            </p>
          </div>
        );
      } else {
        return (
          <div>
            <p>
              Your IP is {this.state.ip} and you live in {this.state.country} (
              {this.state.city}){" "}
            </p>
          </div>
        );
      }
    } else {
      return (
        <div>
          <p>There is an error and I can't find where you live</p>
        </div>
      );
    }
  }
}

export default HomePage;
